// extracted by mini-css-extract-plugin
module.exports = {"copyright":"_3Iqdog","madeWith":"_25Xi-i"};